import React, { useReducer, useEffect, useRef } from "react";
import Sys from "./lib.r2/utils/SystemUtils";
import SoundUtils from "./lib.r2/utils/SoundUtils";
// import * as localForage from "localforage";
import { CacheManager2 } from "./lib.r2/utils/CacheManager2";
import { mseConnect, mseStart } from './MseProvider';
import UI from "./lib.r2/ui/ui-controls";
import { StyleButton } from "./Assets";
import store from "./Store";
import DateFormat from "./lib.r2/utils/DateFormat";

export const Action = React.createContext();
export const State = React.createContext();

const cm = CacheManager2;

const emptyBundle = {
	_new			: true,
	id				: null,
	articleNo		: "",
	attributes		: {},
	bundlegroup_id	: null,
	bundletype		: null,
	bundletype_id	: null,
	child_id		: null,
	child			: {
		child			: {
			attributes 	: {},
			gtin		: "",
			level		: "unit"
		},
		attributes 	: {},
		gtin		: "",
		level		: "pack"
	},
	gtin			: "",
	gtins			: [],
	item			: null,
	item_id			: null,
	level			: "case",
	loadcarrier		: null,
	loadcarrier_id	: null,
	name			: "neuer Artikel",
	parent_id		: null,
	status			: "incomplete",
	warehouse		: null,
	warehouse_id	: null,
	comment			: ''
}


// ---------------------------------------------------------------------------- initialState
const initialState = {
	status		: 'LOADING ...',
	lang		: 'de',
	config		: null,
	bundles		: null,
	search		: [],
	searchString : '',
	setup		: null,
	user		: null,
	mandate		: null,
	warehouse	: null,		//current selected warehouse
	_warehouses	: null,

	mseError	: false,
	mseErrorCode	: '',
	mseErrorMessage	: '',

	isCameraInit	: false,
	isError		: false,
	isInit		: false,
	isExit		: false,
	isLoggedIn	: false,
	isIdle		: false,
	isOnline	: false,
	isSaved		: 0,			//0 = saving, 1 = true, 2 = network error, saved locally
	isScanning	: false,		//scan via native barcode scanner is running
	isCopy		: false,
	canCreateNewBundle	: false,	//current user can create new bundle

	openMenu	: false,
	selectedPage: 'login-page',
	mode		: 'scan',		//scan, gtin, photo
	photoItem	: null,			//placeholder for page-image component.content
	photoItems	: {},			//lookpup list for all photos of the current bundle to save
	// photos		: [],
	// userName	: '',
	// userPW		: '',
	bundle		: null,
	gtin		: null,			//last scaned gtin-code
	teachInPage	: -1,
	lastPage	: -1,
	scan		: null,			//current scan process
	canvas		: null,			//current gtin canvas
	mainColor	: '#029AA9',	//'#FFEC00',
	scanLog		: [],
	scanLogOpen	: false,

	isConnected	: false,
	isDebug		: false,

	isSimulation : false,		//window.location.hostname.startsWith('localhost'),
	tables 		: {},
	_cache		: {}			//photo cache till bundle is saved successfully
};


// ---------------------------------------------------------------------------- Provider
export default function Provider(props){
	const [state, dispatch] = useReducer(Reducer, initialState);
	// const popup = useRef();

	useEffect(() => {
		state.action = action.current;		//reference the dispatcher himself
		state.dispatch = dispatch;

		store.action = action.current
		store.dispatch = dispatch;

		action.current('init');
		return () => {};
	}, []);


	// ------------------------------------------------------------------------ action middleware
	// dont use the state here! state is only the init-state
	//
	const action = useRef( async (type, payload) => {
		// console.log('action:', type, payload || '');

		switch (type){
		case 'exit-on':
			return window.close();

		case 'init':
			await initConfig();						//load config

			state.setup = {}// {mandates:[]}
			state.bundles = []
			state.user = await store.cache.getItem('user')	//get precached user

			// console.info('loading complete!', state)
			return dispatch({type:'init'});

		case 'login':
			store.setUser(payload)

			await loadSetup();		//load setup data
			await loadData();		//load bundles data
			return dispatch({type, payload});	//-> login

		case 'reload-setup':
			dispatch({type:'reload'});
			await loadSetup();	//load setup data
			if (state.setup) await loadData();		//load bundles data
			return;

		case 'reload':
			dispatch({type:'reload'});
			await loadData();
			return;

		default:
			return dispatch({type, payload});
		}
	})


	// ------------------------------------------------------------------------ initConfig
	const initConfig = async () => {
		console.log('load config ...');
		await store.init()

		let config = store.config

		if (!config) return dispatch({type:'error', payload:'error on loading config.json!'});

		state.isDebug = global.urlVars.debug === '1' || config.debug;

		if (parseInt(global.urlVars.test) > 0) config.createTestWarehouse = parseInt(global.urlVars.test)

		document.addEventListener("message", onMessage, false);	//android-parent

		if (window.ReactNativeWebView){
			window.ReactNativeWebView.postMessage('hello');
		}

		state.config = config;

		state.scanLog = await store.cache.getItem('scan-log') || [];

		let url = config.api.url + 'teachin/releaseNotes'
		// let res = await fetch(url).catch(err => err)	//, {mode:'no-cors'}
		// let log = res.ok? await res.text() : 'error on loading release-log from ' + url + '\n' + res
		// state.releaseLog = log

		let log = await store.fetch(url, 'text')
		if (log){
			store.set({releaseLog:log})
			state.releaseLog = log
		}

		dispatch({type:'config', payload:config});
	}


	// ------------------------------------------------------------------------ onMessage
	const onMessage = e => {
		if (e.data.startsWith('hello')){		//hello back from native app
			if (state.isDebug) alert('native-app connected!');
			dispatch({type:'connected'});

		}else if (e.data.startsWith('scan:')){		//scan data receifed
			let scan = JSON.parse(e.data.split('scan:')[1]);

			if (state.isDebug){
				Sys.alert();
				alert('scan-data receifed:\n' + e.data.split('scan:')[1]);
				
			}else{
				dispatch({type:'scan-result', payload:{gtin:scan.data, canvas:null}});
			}
		}
	}


	// ------------------------------------------------------------------------ loadSetup
	const loadSetup = async () => {
		let url = state.config.api.url + 'setup';

console.log('load setup data:', url, '...')	
		let setupData = await store.fetch(url, null, null, 'setup-data');

		if (!setupData) return dispatch({type:'error', payload:'error on loading setup data! ' + url});

		await setVersion(setupData)

		parseImages(setupData);		//preload icons

		global.labels = setupData.labels;

		state.setup = setupData;
		dispatch({type:'setup', payload:setupData});
	}


	// ------------------------------------------------------------------------ setVersion
	const setVersion = async setupData => {
		let lastVersion = await store.cache.getItem('lastVersion');

		if (lastVersion){
			global.appVersion = lastVersion.version
			global.release = lastVersion.release
		}

		if (setupData.version) global.appVersion = setupData.version
		if (setupData.release) global.release = setupData.release

		store.cache.setItem('lastVersion', {version:global.appVersion, release:global.release})
	}


	// ------------------------------------------------------------------------ loadData
	// load or reload bundles data
	const loadData = async e => {
		let bundles = []
		store.cache.removeItem('bundles-data');		//clear old cached bundles

		dispatch({type:'bundles-loaded', payload:bundles});
	}


	// ------------------------------------------------------------------------ parseImages
	// preload all used icons for offline mode
	const parseImages = (setup) => {
		setup.content?.chapters?.forEach(c => {
			c.pages?.forEach(p => {
				p.sections?.forEach(s => {
					s.components?.forEach(co => {
						addImage(co, p);
						co.content?.forEach(cn => {
							addImage(cn, p);
							cn.group?.forEach(cg => {
								addImage(cg, p);
							})
						})
					})
				})
			})
		})

		setup.mandates?.forEach(m => {
			if (m.logo){
				cm.set(m.logo);
			}
		})

		// cm.set('./assets/status_on.svg');
		// cm.set('./assets/status_off.svg');
	}


	// ------------------------------------------------------------------------ addImage
	const addImage = (src, parent) => {
		let img = src.icon || src.logo;
		if (!img) return;

		let p = img.indexOf('/', 10) + 1;
		let url = state.config.api.server + img.substring(p);

		// console.log('---add', url, parent);
		if (src.icon) src.icon = url;		//replace icon url
		else if (src.logo) src.logo = url;	//replace logo url
		cm.set(url);
	}



	// ------------------------------------------------------------------------ render
	return (
		// !state.setup ?
		!state.isInit ?
			<div id='app-status'>
				<div>{state.status}</div>
				<div id='app-status-box'>
				{state.isError?
					<StyleButton label='wiederholen' onClick={e => action.current('reload-setup')} />
					:
					<UI.Spinner color='#029AA9' style={{margin:'20px'}} />
				}
				</div>
				<div id='app-status-version'>
					{global.appVersion? 'Version: ' + global.appVersion : ''}
					<span>{state.config? ('Build: ' + state.config.version + ' | ' + state.config.release) : ''}</span>
				</div>

				{/* <span>{global.appVersion? 'Version: ' + global.appVersion : ''}</span> */}
			</div>
			:
			<Action.Provider value={action.current}>
				<State.Provider value={state}>
					{props.children}
				</State.Provider>
			</Action.Provider>
	);
};



// ---------------------------------------------------------------------------- Reducer
const Reducer = (state, action) => {
	let type = typeof action === 'string'? action : action.type;
	let p = action.payload;
	let bundle, message

console.info('dispatch:', type, type === 'bundles-updated'? p?.length : p);

	switch (type) {
		case 'camera-init':
			return {...state, isCameraInit:true}

		case 'open-release':
			// https://knapp.jumptoday.group/bl/public/api/teachin/releaseNotes
			return {...state, releaseLogOpen:p};

		case 'open-scanLog':
			if (!state.isLoggedIn) return state
			return {...state, scanLogOpen:p};

		case 'online':		//state changed to online
			// if (p) checkSync(state);

			//check now all cached offline data to upload
			if (state.bundles) store.checkSync(state);
			return {...state, isOnline:p};

		case 'scanLog':
			store.cache.setItem('scan-log', p);
			return {...state, scanLog:p};

		case 'config':		//config loaded
			// console.log('load config:', p);
			return {...state, config:p};

		case 'setup':		//setup data loaded or updated
			p._timestamp = Date.now();
			state.setup = p
			if (state.isInit) checkWarehouse(state);	//set all warehouses and colors if bundles data already loaded
			return {...state, setup:p};

		case 'init':
			return {...state, isInit:true};

		case 'bundles-loaded':		//bundles loaded
			state.bundles = p;
			if (state.isLoggedIn) checkWarehouse(state);	//set all warehouses and colors (first time)

			return {...state, bundles:p, isInit:true};

		case 'reload':
			window.location.reload(true)
			return {...state, isError:false};

		case 'bundles-updated':			//update bundles
			// p = new loaded bundles
			if (state.bundle){		//current bundle in process
				let id = p.findIndex(b => b.id === state.bundle.id);
				if (id >= 0){
					// console.log('replace current bundle index:', id);
					p[id] = state.bundle;
				}
			}

			if (state._warehouses){
				state._warehouses.forEach(w => {
					w._bundles = p.filter(b => b.level === 'case' && b.warehouse_id === w.id);
				})
			}

			return {...state, bundles:p};

		case 'exit':
			return {...state, isExit:true};

		case 'exit-off':
			return {...state, isExit:false};
	
		case 'error':		//app error. needs to reload
			if (state.isInit){
				let message = {
					title: global.getLabel('warning-title', 'Warning!'),
					text: p,
					buttons: [{label:'reload', action:'reload'}]
				}
				return {...state, message, isError:true};
			}else{
				return {...state, status:p, isError:true};
			}

		case 'login':
			state.user = p
			store.setInfo('user', p.name + ' ' + p.email)
			// console.log('user:', p)

			store.language = state.setup.languages?.find(e => e.id === store.user.language_id)		//[payload.language_id - 1] || 'en'
			global.lang = store.language?.shortcode || 'de'
			console.info('language:', global.lang, store.language)
	
			// console.log('user can create new bundles:', state.canCreateNewBundle)
			if (state.isInit) checkWarehouse(state);		//set all warehouses and colors
			return {...state, user:p, isLoggedIn:true, selectedPage:'start-page', bundles:[]};

		case 'logoff':
			if (!state.isOnline){
				return {
					...state,
					message: {
						title: global.getLabel('warning-title', 'Warning!'),
						text: global.getLabel('warning-logoff', 'The user can only be changed when the application is online'),
						buttons: [{label:'OK', action:'message-close'}]
					}
				}
			}

			sessionStorage.removeItem('user')

			store.setInfo({'user':null, 'mandate':null, 'warehouse':null, 'bundles':null, 'bundle':null})

			global.cameraIsInit = false		//react the camera for first click
			return {
				...state,
				isLoggedIn	: false,
				selectedPage : 'login-page',
				warehouse 	: null,
				user 		: null,
				mandate 	: null,
				searchString : '',
				bundles 	: null,
				bundle		: null,
				teachInPage	: -1,
				scan		: null,
				canvas		: null,
				isCopy		: false,
				photoItems	: {}
			}

		case 'home':	//reset current scan
			// console.log('from', state.selectedPage)
			let page

			page = 'start-page'
			let _wh = state.warehouse

			if (state.warehouse?.disableBarcodeScan){
				if (state.selectedPage === 'search-page'){
					_wh = null
				}else{
					page = 'search-page'
				}
			}

			// if (state.mandate?.warehouses?.length > 1){

			// }else{

			// }
			// if (state.selectedPage === 'search-page' && state.mandate?.warehouses?.length > 1){
			// if ((state.selectedPage === 'search-page' && state.mandate?.warehouses?.length > 1)
			// 	|| !state.warehouse?.disableBarcodeScan){
			// 		// go back from search-page to warehouse selection
			// 	page = 'start-page'
			// }else{
			// 	// page = state.warehouse?.disableBarcodeScan? 'search-page' : 'start-page'
			// 	page = 'search-page'
			// }

			// let _wh = page === 'start-page'? null : state.warehouse

			// console.log('to', page)

			store.setInfo({'warehouse':_wh, 'bundles':null, 'bundle':null})

			return {...state,
				selectedPage	: page,
				// warehouse		: state.warehouse?.disableBarcodeScan? null : state.warehouse,
				warehouse		: _wh,
				searchString	: '',
				teachInPage		: 0,
				lastPage		: -1,
				bundle			: null,
				scan			: null,
				canvas			: null,
				isCopy			: false,
				photoItem		: null,
				photoItems		: {}
			};

		case 'check-browser':
			let browser = Sys.getBrowser()
			let agent = navigator.userAgent

			if (!browser.startsWith('Google Chrome')){
				let message = {
					title: global.getLabel('warning-title', 'Warning!'),
					text: global.getLabel('warning-browser', 'The application is optimized for Google Chrome')
						+ '\n(' + browser + '\n' + agent + ')',
					buttons: [{label:'OK', action:'message-close'}]
				}
				return {...state, message}
			}else{
				return state
			}
		case 'goto':
			return {...state, selectedPage:p};

		case 'connected':
			//native app successfully connected (zebra barcode-scanner)
			return {...state, isConnected:true};

		case 'warehouse_remove':
			store.setInfo({'warehouse':null, 'bundles':null, 'bundle':null})
			return {...state, warehouse:null};
		
		case 'select-warehouse':
			// let wh = state._warehouses.find(w => w.name === p);
			let wh = state.mandate.warehouses[p];

			// if (wh.settings){
			// 	let settings = JSON.parse(wh.settings)
			// 	wh._startSettings = settings
			// }

			// ---check if barcodeScan is disabled in the start settings
			if (wh.teachin){
				let start = wh.teachin.chapters.find(ch => ch.name === 'start')
				if (start){
					let settings = {}
					start.pages?.forEach(p => {
						settings[p.name] = p.settings
					})
					wh._startSettings = settings
	
					// wh.disableBarcodeScan = settings?.search?.enableBarcodeScan === false && settings?.search?.enableSearch === false
					wh.disableBarcodeScan = settings?.search?.enableBarcodeScan === false
				}

			}else{	//create manually if missing
				wh._startSettings = {
					search: {enableBarcodeScan:true, enableSearch:true},
					start: {allowCreateVariant:true, enableIncompletePallet:true, enableLikeBundleCopy:true}
				}
				wh.disableBarcodeScan = false
			}

//test disableBarcodeScan
// wh.disableBarcodeScan = true

			// let wh = state._warehouses[p];
			// console.log('selected warehouse:', wh?.id, wh);

			// state.warehouse = wh;
// state.warehouse.allowCreateItem = 1		//only for testing

			// if (!wh._bundles?.length){
			store.loadWarehouseBundles(state, wh)		//async!	-> warehouse-bundles-loaded

			return {...state, message:{
				text: wh.test ? 'preparing test data for ' + state.config.createTestWarehouse + ' articles ...'
					: global.getLabel('bundles_loading', 'loading bundles') + ' ...'
			}}

			// }else{
			// 	console.log('select warehouse:', wh)

			// 	state.warehouse = wh;
			// 	// state.warehouse._bundles = state.bundles.filter(b => b.level === 'case' && b.warehouse_id === state.warehouse.id);
			// 	// console.log('warehouse bundles:', state.warehouse._bundles.length);

			// 	store.setInfo('bundles', wh._bundles.length)
			// 	store.set({'settings':wh._startSettings})

			// 	let selectedPage = wh.disableBarcodeScan? 'search-page' : 'start-page'
			// 	return {...state, message:null, warehouse:wh, selectedPage};
			// }

		case 'warehouse-bundles-loaded':		//from loadWarehouseBundles
			state.warehouse = p;

			state.bundles = p._bundles			//we need only the warehouse bundles

			store.setInfo('warehouse', p.name + ' (articles: ' + p._bundles?.length + ')')

			store.parsePages(p, state.setup)

			//check now all cached offline data to upload
			if (state.isOnline) store.checkSync(state)

			let selectedPage = p.disableBarcodeScan? 'search-page' : 'start-page'
			return {...state, message:null, warehouse:p, selectedPage};

		case 'warehouse-bundles-error':		//from loadWarehouseBundles
			return state

		case 'scan-barcode':		//scan from native device barcode scanner
			if (window.ReactNativeWebView){
				window.ReactNativeWebView.postMessage('scan');		//-> scan-result
				return {...state, isScanning:true, mode:p};

			}else{
				// let message = 'No Barcode-Scanner detected!';
				message = {
					text: 'No Barcode-Scanner detected!',
					buttons: [{label:'OK', action:'message-close'}]
				}
				return {...state, isScanning:true, mode:p, message};
			}

		case 'scan-start':			//open camera scanner
			if (!state.isCameraInit){
				store.initCamera()
				return state
			}
			return {...state, selectedPage:'scanner-page', mode:p, isScanning:true};

		case 'scan-close':
			store.stopCamera()

			return {...state,
				isScanning:false,
				selectedPage:state.mode === 'scan'? 'start-page' : 'teach-in-page',
				mode:null,
				message:null,
				photoItem:null,		//clear the current photoItem reference
			};

		case 'scan-error':
			message = {
				title: global.getLabel('warning-title', 'Warning!'),
				text: global.getLabel('warning-camera', 'Camera not detected'),
				buttons: [{label:'OK', action:'message-close'}]
			}
			return {...state, isScanning:false,
				// selectedPage:state.mode === 'scan'? 'start-page' : 'teach-in-page',
				mode:null,
				message
			};
	
		case 'scan-result':			//p = {gtin, canvas} from camera- or barcode-scan
			if (!state.isScanning) return state;

			let gtin = p.gtin;
			// let num = 14 - gtin.length;					//number of missing 0 on beginning
			// if (num) gtin = _.padStart(gtin, 14, '0');	//append '0' on start for 14dig

			// let gtin = 	p.gtin;
			// console.log('mode:', state.mode, 'gtin:', gtin);

			if (state.mode === 'gtin'){		//gtin-scan
				state.bundleItem.gtin = gtin;
				//goto TeachInPage
				return {...state, searchString:gtin, selectedPage:'teach-in-page', mode:null, message:null, isScanning:false};		//return to last selected teach-in page

			}else{							//default search-scan (mode = scan)
				store.createScan(state, 'scan');

				bundle = store.findGtinBundle(state.warehouse._bundles, gtin)[0]

				if (bundle){
					state.bundle = JSON.parse(JSON.stringify(bundle));		//create working deep copy from original bundly
	
					store.parseBundle(state);
					
					return {...state, searchString:gtin, gtin, selectedPage:'filter-page',
						mode:null, canvas:p.canvas, message:null, isScanning:false};	//goto FilterPage

				}else{	//no bundle found
					// console.log('no matched bundle found with gtin:', gtin);

					return {...state,
						searchString:gtin,
						selectedPage:'search-page', mode:null, canvas:p.canvas,
						message:null, isScanning:false};		//goto search page
				}
			}

		case 'photo-start':
			// p = component.content
			if (!state.isCameraInit) return state		//camera not active

			// console.log('create photo for:', p)		photoItem = current active photo view
			return {...state, selectedPage:'scanner-page', mode:'photo', photoItem:p};

		case 'photo-complete':		//p = canvas from barcodeScanner
			let pi = state.photoItem

			//---add to image list for upload when saving
			// console.log('--- add image to photoItems:', pi._bundle.id + '.' + pi.attribute, pi)
			// state.photoItems[pi._bundle.id + '.' + pi.attribute] = pi	//e.g. 387889.image_pallet

			let dataUrl = p.toDataURL('image/jpeg', 0.9)	//from canvas
			pi._photo = dataUrl;			//use the image data till the bundle is saved

			//---create blob for upload when saving
			// p.toBlob(blob => {pi._blob = blob}, 'image/jpeg', 0.9);		//, 'image/jpeg', 0.9);
			// p.toBlob(blob => {
			// 	pi._bundle._imageCache[pi.attribute] = blob
			// }, 'image/jpeg', 0.9);		//, 'image/jpeg', 0.9);

			// if (!pi._bundle._imageCache) pi._bundle._imageCache = {}

			pi._bundle.attributes[pi.attribute] = dataUrl
			console.log('photoItem:', pi)

			//goto TeachInPage
			return {...state, selectedPage:'teach-in-page', mode:'scan'};	//return to last selected teach-in page
				
		case 'photo-clear':		//remove existing photo
			// console.log('---remove photo', p)
			if (p._bundle?.attributes?.[p.attribute]) p._bundle.attributes[p.attribute] = null
			// delete p._photo
			return state

		case 'openMenu':
			return {...state, openMenu:true};

		case 'closeMenu':
			return {...state, openMenu:false};

		case 'search-open':
			return {...state, selectedPage:'search-page'};

		case 'search-complete':		//p = bundle;
			if (!p.gtin){
				alert('Product ' + p.name + ' has no gtin-code!');
				return state;
			}

			state.bundle = JSON.parse(JSON.stringify(p));		//create working deep copy
console.info('select bundle:', state.bundle);

			store.setInfo('bundle', '#' + state.bundle.id + ': ' + state.bundle.name
				+ (state.bundle.articleNo? ' ['+state.bundle.articleNo+']' : ''))

			store.createScan(state, 'search');
			// parseBundle(state, p);

			if (!p.bundletype_id){		//if no bundletype_id exist got to the search-Result page
				// console.log('bundle', p.id, 'is incomplete!');
				return {...state, selectedPage:'filter-page'};

			}else{						//else parse the selected bundle and start with teach-in process
				store.parseBundle(state);
				// return {...state, selectedPage:'teach-in-page', teachInPage:0};
				// return {...state, selectedPage:'clone-page'};
				return {...state, selectedPage:'filter-page'};
			}

		case 'create-new':
			// console.log('create new bundle from gtin:', state.searchString)
			state.gtin = state.searchString
			selectBundle(state, ['new', false, true])
			return {...state, selectedPage:'clone-page'}

		case 'teach-in-select':			//clicked: COPY & START | p = [select, incomplete, variant]
			selectBundle(state, p)

			if (p[2]){		//clone
console.log('-> clone-page')			
				return {...state, selectedPage:'clone-page'};		//open clone-page
			}else{
console.log('-> teach-in-page')			
				return {...state, selectedPage:'teach-in-page', teachInPage:0};		//start teach-in
			}

		case 'teach-in-clone':
			state.bundle.name = p;
			state.bundle._clone = true;
			state.bundle._search = p.toLowerCase() + ' ' + state.bundle._search

			store.createScan(state, 'create');

			store.setInfo('bundle', null)

			return {...state, selectedPage:'teach-in-page', teachInPage:0};		//start teach-in

		case 'teach-in-start':
			return {...state, selectedPage:'teach-in-page', teachInPage:getPage(state, 0) || 0};		//start teach-in
	
		case 'selectPage':
			return {...state, selectedPage:p};

		case 'back':	//logoff
			sessionStorage.removeItem('user')
			return {...state, selectedPage:'login-page'};

		case 'goBack':	//from native app back-button
			// console.log('goBack from:', state.selectedPage, '...');

			switch(state.selectedPage){
				case 'login-page':
					// return window.close();
					break;

				case 'start-page':		//logoff
					// sessionStorage.removeItem('user')
					return {...state, isLoggedIn:false, selectedPage:'login-page', user:null, mandate:null, searchString:''};

				case 'scanner-page':	//scan-close
					return {...state, isScanning:false, selectedPage:state.mode === 'scan'? 'start-page' : 'teach-in-page', mode:null, message:null};

				case 'search-page':		//home
					return {...state, selectedPage:'start-page',
					searchString:'', teachInPage:0, lastPage:-1, bundle:null, scan:null, canvas:null, isCopy:false};

				case 'filter-page':		//teach-in-close
					return {...state, selectedPage:'search-page', teachInPage:-1, bundle:null, scan:null, canvas:null, isCopy:false};		//goto search-page

				case 'teach-in-page':
					p = getPage(state, state.teachInPage-1);
					return p === null?		//teach-in-close
						{...state, selectedPage:'search-page', teachInPage:-1, bundle:null, scan:null, canvas:null, isCopy:false}
						: {...state, teachInPage:p, lastPage:state.teachInPage};

				default:
			}
			return state;

		case 'next':
			return state;

		case 'teach-pack':
			return state.setup._pack? {...state, teachInPage:state.setup._pack._pageId, lastPage:state.teachInPage} : state;

		case 'teach-unit':
			return state.setup._unit? {...state, teachInPage:state.setup._unit._pageId, lastPage:state.teachInPage} : state;

		case 'teach-in-close':
			// return {...state, selectedPage:'search-page', teachInPage:-1};		//goto SearchPage

			store.setInfo('bundle', null)

			return {...state, selectedPage:'search-page', teachInPage:-1,
				bundle:null, scan:null, canvas:null, isCopy:false, photoItems:{}, gtin:null
			};		//goto search-page
			
		case 'teach-in-prev':
			p = getPage(state, state.teachInPage-1);
			// console.log('selected page:', p, state.setup._pages[p])
			return p === null?
				{...state, selectedPage:'search-page', teachInPage:-1, bundle:null, scan:null, canvas:null, isCopy:false}
				: {...state, teachInPage:p, lastPage:state.teachInPage, useNestedScan:false};

		case 'teach-in-next':
			var pages = state.setup._pages;
			let last = pages[state.teachInPage]		//current page

			if (state.measure_bundle && last._settings?.enableNestedScan){		//default measure was already done
				console.table({
					'nestedScan already done:': state.useNestedScan,		//nestedScan still not done
					'table-scan page active:': last?._active,
					'enableNestedScan in settings:': last._settings?.enableNestedScan,
					'bundleType nestable:': last._bundle?._bundleType?.nestable,
				})
			}
			
			if (!state.useNestedScan
				&& state.measure_bundle				//default measure was already done
				&& last?._active
				&& last._settings?.enableNestedScan
				&& last._bundle?._bundleType?.nestable
				&& last._bundle?._tableData			//table selected
				){
				return {...state, message:{
					// title: 'REFERENZIERUNG',
					text: global.getLabel('multiscan-nested', 'start nested scan?'),
					buttons: [
						{label:global.getLabel('multiscan-start-nested', 'start'), action:'nested-start'},
						{label:global.getLabel('cancel'), action:'nested-canceled'},
					]
				}}
			}

			p = getPage(state, state.teachInPage+1);
			// console.log('selected page:', p, state.setup._pages[p])
			return p === null? state : {...state, teachInPage:p, lastPage:state.teachInPage, useNestedScan:false, measure_bundle:null};

		case 'nested-canceled':		//from "start nested scan?" dialog
			// return {...state, message:null, useNestedScan:0};
			p = getPage(state, state.teachInPage+1);
			return p === null? {...state, message:null, useNestedScan:false}
				: {...state, teachInPage:p, lastPage:state.teachInPage, useNestedScan:false, message:null};

		case 'nested-start':		//from "start nested scan?" dialog
			if (!state.measure_bundle._tableData) return state;		//no table scan-table selected

			state.useNestedScan = true
			// mseStart(state);
			mseConnect(state);	//start nested scan now and wait for measure-complete or mse-error ...
			return {...state, message:null, useNestedScan:true, measure_on:true};

		case 'teach-in-page':		//select teachIn-page
			p = getPage(state, p);
			// console.log('selected page:', p, state.setup._pages[p])
			return p === null? state : {...state, teachInPage:p, lastPage:state.teachInPage};

		case 'teach-in-complete':
			let sb = state.bundle
			if (!sb.gtin){
				if (sb.child?.gtin) sb.gtin = sb.child.gtin
				else if (sb.child?.child?.gtin) sb.gtin = sb.child.child.gtin

				if (!sb.gtin){
					alert('Product ' + state.bundle.name + ' has no gtin-code!');
					return state;
				}
			}

			if (sb.test){		//test bundle
				return {...state, isSaved:3, selectedPage:'complete-page', teachInPage:0, lastPage:-1, message:null};
			}

			store.parseAndSaveResult(state);		//-> sendResult

			return {...state, message:'saving bundle ...'};		//saving now

		case 'teach-in-saved':	//p 1 = saved, 2 = cached
			return {...state, isSaved:p, selectedPage:'complete-page', teachInPage:0, lastPage:-1, message:null};

		case 'measure-start':		//from TeachInPage.Multiscan page
			if (!p){
				return {...state, mseError:true, mseErrorCode:null, mseErrorMessage:'no bundle selected!', message:null};
			}

			var table = p._tableData;		//get selected scan-table data
			if (!table){
				return {...state, mseError:true, mseErrorCode:null,
					mseErrorMessage:global.getLabel('multiscan-no-table-selected', 'no table selected!'), message:null};
			}

			// console.log('---start multiscan for bundle:', p, '| table:', table);
			state.measure_bundle = p;
			state.measure_on = true;
		
			let t = Math.floor(Date.now() / 1000);

			if (!table._init || table._time + 1800 < t){		//timeout = 30min.
				table._init = false;
				let mode = ' (' + p.level + ': ' + (p._multiscanMode || 'complex') + ')'
				return {...state, message:{
					// title: 'REFERENZIERUNG',
					text: global.getLabel('multiscan-ref', 'Multiscan Referenzierung starten?') + mode,
					buttons: [
						{label:global.getLabel('multiscan-start-ref'), action:'ref-start'},
						{label:global.getLabel('cancel'), action:'measure-complete'},
					]
				}}
			}else{
				mseConnect(state);
				return {...state};
			}
		case 'ref-start':
			if (p) state.measure_bundle = p;

			var table = state.measure_bundle._tableData
			if (!table){
				alert('no table data!')
				return state
			}

			if (p) state.measure_bundle = p;	//reference only

			table._init = false;
			mseConnect(state);
			return {...state};

		case 'ref-complete':
			var table = state.measure_bundle._tableData
			table._init = true;
			table._time = Math.floor(Date.now() / 1000);

			!state.measure_on && SoundUtils.beep();

			message = {
				// title: 'REFERENZIERUNG',
				text: global.getLabel('multiscan-ref-done', 'Multiscan Referenzierung fertig!'),
				buttons: state.measure_on? [
					{label:global.getLabel('start-scan'), action:'mse-start'},
					{label:global.getLabel('cancel', 'Abbrechen'), action:'measure-complete'}
				] : [
					{label:'OK', action:'measure-complete'},
				]
			}
			return {...state, message}

		case 'mse-start':	//from MseProvide.mseConnect
			mseStart(state);		//start measure now and wait for measure-complete or mse-error ...
			return {...state, message:null, measure_on:true};

		case 'measure-complete':
			if (p) SoundUtils.beep();	//we have a result!
			// if (state.useNestedScan) state.useNestedScan = false	//nested scan finished

			return {...state, measure_on:false, mseError:false, message:null};
	
		case 'mse-error':
			return {...state, mseError:true, mseErrorCode:p.code, mseErrorMessage:p.message, message:null};

		case 'mse-ref':
			return {...state, mseError:false, measure_on:true};

		case 'message':
			return {...state, message:p};

		case 'message-close':
			return {...state, message:null};

		case 'skip-pack-unit':
		// deactivate all pack-unit pages
			var pages = 0;
			if (p){		//button selected
				state.setup._chapters.forEach(ch => {
					if (ch.name === 'pack' || ch.name === 'unit') ch._valid = false;
					pages += ch._valid? ch._numPages : 0;
				})

			}else{		//not selected
				state.setup._chapters.forEach(ch => {
					if (ch.name === 'pack' || ch.name === 'unit') ch._valid = ch._numPages > 0;
					pages += ch._valid? ch._numPages : 0;
				})
			}
			state.setup._numPages = pages;
			return {...state};

		default: return state;
	}
}


// ------------------------------------------------------------------------ copyBundle
const copyBundle = (from, to) => {
console.log('copy bundle - from', from);
console.log('to:', to);

	from = JSON.parse(JSON.stringify(from));	//create deep copy of source bundle

	to.bundletype_id = from.bundletype_id;
	to.bundlegroup_id = from.bundlegroup_id;
	to.loadcarrier_id = from.loadcarrier_id;
	to.item = from.item
	to.attributes = {...to.attributes, ...from.attributes};		//append attributes

	delete to.attributes.image_iso;
	delete to.attributes.image_front;

	if (from.child){
		to.child = from.child;
		resetChild(to.child, to);
	}
	// console.log('result:', to);
}


// ------------------------------------------------------------------------ resetChild
const resetChild = (child, parent) => {
	child.id = null;
	child.gtin = null;
	child.gtins = [];
	child.name = parent.name;
	// child.item = parent.item;

	if (child.child) resetChild(child.child, parent);
}


// ------------------------------------------------------------------------ getPage
const getPage = (state, p) => {
	if (!state.setup._pages[p] || p === state.teachInPage) return null;

	let pages = state.setup._pages;

	if (pages[p]._active && pages[p]._chapter._active) return p;

	let n = state.setup._numPages-1;

	if (p > state.teachInPage){		//next
		while(p < n && (!pages[p]._active || !pages[p]._chapter._active)){ p ++ };
	}else{		//prev
		while(p > 0 && (!pages[p]._active || !pages[p]._chapter._active)){ p -- };
	}

	return (pages[p]._active && pages[p]._chapter._active)? p : null;
}


// ------------------------------------------------------------------------ checkWarehouse
// after login
const checkWarehouse = (state) => {
	if (!state.user || !state.setup) return

	// if (!state.user || !state.setup?.mandates) return

	// console.log('---check warehouse for user', state.user.name, state.setup);

	// ---search for all warehouses
	state._warehouses = [];
	let whs = {};

	let mandate = state.setup.mandates.find(m => m.id === state.user.mandate_id);

	if (state.config.createTestWarehouse){
		let num = state.config.createTestWarehouse
		if (num > 1000000) num = 1000000;		//max. 1.000.000 articles

		let demo = mandate.warehouses.find(w => w.name === 'Demo Warehouse')
		if (demo){			//create testWarehouse with demo data
			let test = {
				...demo,
				name	: 'Test Warehouse with ' + num + ' Articles',
				test	: true
			}
			mandate.warehouses.unshift(test);
		}
	}

	state.setup.mandates.forEach(m => {
		m.warehouses.forEach(w => {
			if (!whs[w.id]){
				whs[w.id] = true;
				state._warehouses.push(w);
			}
		})
	})

	state.mandate = mandate;
	console.log('mandate:', mandate, state.warehouse)
	store.setInfo('mandate', mandate.name)

	if (state.warehouse){	//warehouse already selected
		// replace with last version from mandate
		state.warehouse = mandate.warehouses.find(w => w.id === state.warehouse.id);
		// store.setInfo('warehouse', state.warehouse.name + ' (articles: ' + state.warehouse._bundles?.length + ')')
	}

	console.log('selected warehouse:', state.warehouse);
}


// ------------------------------------------------------------------------ selectBundle
const selectBundle = (state, p) => {
	console.log('select bundle:', p)
	state.isCopy = false;

	if (p[0] === 'new'){		//if select === 'new' create new article
		// console.log('create new empty bundle!')
		state.bundle = JSON.parse(JSON.stringify(emptyBundle))	//create new empty bundle
		state.bundle.id = '_' + state.gtin		//create temporary id based on the current gtin
		state.bundle.gtin = state.gtin
		state.bundle.gtins = [state.gtin]
		state.bundle.warehouse = {
			id		: state.warehouse.id,
			name	: state.warehouse.name
		}
		state.bundle.warehouse_id = state.warehouse.id

	}else if (p[0]){						// copy selected bundle
		copyBundle(p[0], state.bundle);		//create working copy of the bundle
		state.isCopy = true;
	}

	// ---cleanup data
	if (state.bundle.child){	//PACK
		delete state.bundle.child.item
		delete state.bundle.child.item_id
	}
	if (state.bundle.child?.child){		//UNIT
		delete state.bundle.child.child.item
		delete state.bundle.child.child.item_id
	}

	if (!state.bundle.item) state.bundle.item = {attributes:{}}

	if (!state.bundle.item.attributes) state.bundle.item.attributes = {}
	
	// ---fix item.attributes array with object
	if (Array.isArray(state.bundle.item.attributes)){
		state.bundle.item.attributes = {}
	}

	store.parseBundle(state);

	// activate palette-chapter if incomplete
	let ch = state.setup._chapters.find(c => c.name === 'pallet')
	let v = p? !p[1] : true;
	if (ch){
		ch._active = v;
		ch.pages.forEach((p, i) => p._active = i > 0? v : true)
	}
}


